import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { ArtifactCategory } from '@pages/legal-terms-archive/models/artifact-archive.interface';

@Injectable({
  providedIn: 'root',
})
export class LegalTermsArchiveService {
  private readonly httpClient = inject(HttpClient);

  getArtifacts(): Observable<ArtifactCategory[]> {
    const url = 'api/v1/legal-terms-archive/artifacts';

    return this.httpClient.get<ArtifactCategory[]>(environment.portalApiUrl + url);
  }

  getLegalTermsArtifactBlobById(id: string): Observable<Blob> {
    const url = `api/v1/legal-terms-archive/artifacts/${id}`;

    return this.httpClient.get(environment.portalApiUrl + url, { responseType: 'blob' });
  }
}
